import React from "react";

const RegionDropdown = ({ regions, selectedRegionId, onChange }) => (
    <div className="dashboard-region-form" style={{ margin: 0 }}>
        <label htmlFor="region-select" className="dashboard-region-label">
            Region:
        </label>
        <select
            id="region-select"
            className="dashboard-region-select"
            value={selectedRegionId}
            onChange={e => onChange(e.target.value)}>
            <option value="">Select a region</option>
            {regions.map(region => (
                <option key={region.id} value={region.id}>
                    {region.name}
                </option>
            ))}
        </select>
    </div>
);

export default RegionDropdown;